import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import { getErrorMessage } from "services/UtilityService";
import { showNotification } from 'services/NotificationService';
import ContactModal from "components/BlacklistedContact/BlacklistContactModal";
import { getBlacklistedContactKindLabel } from "lookup/BlacklistedContactConstants";

const RowActionsModal = ({ contactValue, contactType, contactUuid, description, createdBy, onActionComplete }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleDelete = () => {
    sendAuthenticatedAsyncRequest(
      `/blacklisted-contacts/${contactUuid}`,
      'DELETE',
      null,
      () => {
        showNotification({
          title: 'Action Successful!',
          message: `Blacklisted contact ${contactValue} deleted successfully.`,
          position: 'tr',
          type: 'success',
        });
        setShowDelete(false);
        onActionComplete?.();
      },
      (r) => {
        const errorCode = r?.errorCode || r?.response?.data?.errorCode;
        const errorMsg = getErrorMessage(errorCode) || getErrorMessage('BLACKLIST_ENTRY_DELETE_FAILED');

        showNotification({
          title: 'Error!',
          message: errorMsg,
          position: 'tr',
          type: 'error',
        });
      }
    );
  };

  return (
    <>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <MdModeEdit
          size={20}
          title="Edit"
          style={{ cursor: 'pointer' }}
          onClick={() => setShowEdit(true)}
        />
        <MdDeleteForever
          size={20}
          title="Delete"
          style={{ cursor: 'pointer' }}
          onClick={() => setShowDelete(true)}
        />
      </div>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remove Blacklisted Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove the following {getBlacklistedContactKindLabel(contactType)}: <strong>{contactValue}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDelete(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDelete}>Remove Contact</Button>
        </Modal.Footer>
      </Modal>

      <ContactModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        createdBy={createdBy}
        contactToEdit={{
          id: contactUuid,
          contactValue,
          contactType,
          description,
        }}
        onActionComplete={onActionComplete}
      />
    </>
  );
};

export default RowActionsModal;
